import { Editor } from './Editor.jsx'
import './css/App.scss';

const App = () => {
  return (
    <div className="App">
      <Editor />
    </div>
  )
}

export default App;
